module.exports = __webpack_public_path__ + "static/media/dumpTruck_gray.36f8a380.svg";